/*
  Client-side switcher for the theme's "gang" media.

  Media tagged `#<option>_<value>` in its alt text is rendered for EVERY option
  value at once -- all 34 slides of all three shades are already in the DOM --
  and section-main-product.css shows only the ones marked `.gang__active`.
  Those classes are set by Liquid, which is why product-info.js used to force a
  FULL PAGE fetch (879KB) and replace <main> on every variant click just to move
  a class name. This moves it in place instead: nothing about the gallery needs
  the server, because every shade's media is already here.

  Two classes have to move together:
    - `gang__active` filters WHICH media belong to the value
    - `is-active` picks the ONE that is on screen, because the thumbnail_slider
      layout hides `.product__media-item.is-active ~ .product__media-item.is-active`
  Moving only the first leaves every slide of the new value hidden.
*/
window.IrisGangMedia = {
  /* Reads the connect handle off the checked option input. The handle is
     rendered by Liquid (product-variant-options.liquid) rather than rebuilt
     here, so this never has to reimplement `handleize`. */
  currentConnect(scope) {
    const root = scope || document;
    const checked = root.querySelector('variant-selects[data-primary] input:checked[data-gang-connect]');
    return checked ? checked.dataset.gangConnect : null;
  },

  applyFromSelection(scope) {
    return this.apply(this.currentConnect(scope));
  },

  apply(connect) {
    if (!connect) return false;
    const option = connect.split('_')[0];
    const all = document.querySelectorAll(`[data-gang-option="${option}"]`);
    if (!all.length) return false;

    // A value with no tagged media would otherwise blank the whole gallery.
    const gallery = document.querySelector('media-gallery');
    const viewer = gallery && gallery.querySelector('[id^="GalleryViewer"]');
    const first = viewer && viewer.querySelector(`[data-gang-connect="${connect}"][data-media-id]`);
    if (!first) return false;

    all.forEach((el) => {
      el.classList.toggle('gang__active', el.dataset.gangConnect === connect);
    });

    // The theme's own thumbnail-click path: moves is-active, syncs the
    // thumbnail and aria-current, announces the change. scrollIntoView is off
    // so the page never jumps away from whatever the shopper is looking at.
    if (typeof gallery.setActiveMedia === 'function') {
      try { gallery.setActiveMedia(first.dataset.mediaId, false, false); } catch (e) { /* gallery not ready */ }
    }

    // initPages() re-filters on clientWidth > 0 -- exactly what just changed --
    // so the arrows and slide counter match the new set.
    document.querySelectorAll('product-gallery, thumbnail-slider').forEach((sl) => {
      if (typeof sl.initPages === 'function') {
        try { sl.initPages(); } catch (e) { /* slider not ready */ }
      }
    });

    return true;
  },
};
